import { InvoiceDisplayStatusV2, PaymentDetailType } from 'anchor-scout-common/types';
const NUMBER_ONLY_STATUS_BUCKET_IDS = [
    'paid',
    'pending',
    'overdue',
    'issued',
    'processing',
    'refunded',
    'voided'
];
const NUMBER_ONLY_STATUS_BUCKETS = new Set(NUMBER_ONLY_STATUS_BUCKET_IDS);
export const isNumberOnlyStatusBucket = (id)=>NUMBER_ONLY_STATUS_BUCKETS.has(id);
export const CARD_LOCALE_KEY = {
    'collection-rate': 'collectionRate',
    'anchor-vs-external': 'anchorVsExternal',
    'avg-days-to-pay': 'avgDaysToPay',
    'avg-invoice': 'avgInvoice',
    outstanding: 'outstanding',
    'aging-breakdown': 'agingBreakdown',
    pending: 'pending',
    issued: 'issued',
    processing: 'processing',
    paid: 'paid',
    overdue: 'overdue',
    voided: 'voided',
    refunded: 'refunded'
};
const compactCurrencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    maximumFractionDigits: 1
});
const fullCurrencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});
export const formatCompactCurrency = (amount)=>compactCurrencyFormatter.format(amount);
export const formatCurrency = (amount)=>fullCurrencyFormatter.format(amount);
export const formatPercent = (ratio)=>"".concat(Math.round(ratio * 100), "%");
const OPEN_STATUSES = [
    InvoiceDisplayStatusV2.Issued,
    InvoiceDisplayStatusV2.Pending,
    InvoiceDisplayStatusV2.Overdue,
    InvoiceDisplayStatusV2.Processing
];
const PAID_ONLY = [
    InvoiceDisplayStatusV2.Paid
];
const CARD_FILTERS = {
    'collection-rate': {
        displayStatusV2: PAID_ONLY
    },
    'anchor-vs-external': {
        displayStatusV2: PAID_ONLY
    },
    'avg-days-to-pay': {
        displayStatusV2: PAID_ONLY
    },
    'avg-invoice': {
        displayStatusV2: []
    },
    outstanding: {
        displayStatusV2: OPEN_STATUSES
    },
    'aging-breakdown': {
        displayStatusV2: OPEN_STATUSES
    },
    paid: {
        displayStatusV2: PAID_ONLY
    },
    pending: {
        displayStatusV2: [
            InvoiceDisplayStatusV2.Pending,
            InvoiceDisplayStatusV2.Disputed
        ]
    },
    overdue: {
        displayStatusV2: [
            InvoiceDisplayStatusV2.Overdue
        ]
    },
    issued: {
        displayStatusV2: [
            InvoiceDisplayStatusV2.Issued
        ]
    },
    processing: {
        displayStatusV2: [
            InvoiceDisplayStatusV2.Processing
        ]
    },
    voided: {
        displayStatusV2: [
            InvoiceDisplayStatusV2.Voided
        ]
    },
    refunded: {
        displayStatusV2: [
            InvoiceDisplayStatusV2.Refunded,
            InvoiceDisplayStatusV2.PartiallyRefunded,
            InvoiceDisplayStatusV2.RefundFailed
        ]
    }
};
export const filterForCard = (cardId)=>CARD_FILTERS[cardId];
export const filterForOutstandingSegment = (segmentId)=>{
    var _map_segmentId;
    const map = {
        issued: {
            displayStatusV2: [
                InvoiceDisplayStatusV2.Issued
            ]
        },
        processing: {
            displayStatusV2: [
                InvoiceDisplayStatusV2.Processing
            ]
        },
        pending: {
            displayStatusV2: [
                InvoiceDisplayStatusV2.Pending,
                InvoiceDisplayStatusV2.Disputed
            ]
        },
        overdue: {
            displayStatusV2: [
                InvoiceDisplayStatusV2.Overdue
            ]
        }
    };
    return (_map_segmentId = map[segmentId]) !== null && _map_segmentId !== void 0 ? _map_segmentId : null;
};
export const filterForAgingSegment = (segmentId)=>{
    if (segmentId === 'current') {
        return {
            displayStatusV2: [
                InvoiceDisplayStatusV2.Issued,
                InvoiceDisplayStatusV2.Processing
            ]
        };
    }
    if (segmentId === 'days1to30' || segmentId === 'days31to60' || segmentId === 'days61to90' || segmentId === 'days90plus') {
        return {
            displayStatusV2: [
                InvoiceDisplayStatusV2.Overdue
            ]
        };
    }
    return null;
};
export const filterForAnchorSegment = (segmentId)=>{
    if (segmentId === 'anchorPaid') {
        return {
            displayStatusV2: PAID_ONLY,
            paymentDetails: [
                PaymentDetailType.PaidOnDate
            ]
        };
    }
    if (segmentId === 'externalPaid') {
        return {
            displayStatusV2: PAID_ONLY,
            paymentDetails: [
                PaymentDetailType.PaidExternally
            ]
        };
    }
    return null;
};
